import './BarChart.scss';

import { ResponsiveBar } from '@nivo/bar';
import { Radio } from 'antd';
import type { User } from 'api/models/mainservice';
import type { Codebook } from 'common/models';
import { CustomEmpty } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useState } from 'react';

import type { DashboardData } from '../models';
import { prepareData } from './barChartHelpers';

interface OwnProps {
  data: DashboardData;
  users: User[];
  orderCategories: Codebook[];
}

type SelectedType = 'state' | 'category' | 'assignee';
type SelectedPeriod = 'days' | 'months';

const BarChart = (props: OwnProps) => {
  const { t } = useCustomTranslation();
  const [selectedType, setSelectedType] = useState<SelectedType>('state');
  const [selectedPeriod, setSelectedPeriod] = useState<SelectedPeriod>('days');

  const data = prepareData(
    props.data.orderInterventions,
    t,
    selectedPeriod,
    selectedType,
    props.users,
    props.orderCategories
  );

  let noData = true;
  data.items.forEach((x) => {
    if ((x.total as number) > 0) noData = false;
  });

  return (
    <div className="BarChart">
      <div className="BarChart_controls">
        <Radio.Group
          defaultValue={selectedType}
          onChange={(e) => {
            setSelectedType(e.target.value);
          }}
        >
          <Radio.Button value="state">{t('dashboard:barChart_filter_state')}</Radio.Button>
          <Radio.Button value="category">{t('dashboard:barChart_filter_category')}</Radio.Button>
          <Radio.Button value="assignee">{t('dashboard:barChart_filter_assignee')}</Radio.Button>
        </Radio.Group>
        <Radio.Group
          defaultValue={selectedPeriod}
          onChange={(e) => {
            setSelectedPeriod(e.target.value);
          }}
        >
          <Radio.Button value="days">{t('dashboard:barChart_filter_days')}</Radio.Button>
          <Radio.Button value="months">{t('dashboard:barChart_filter_months')}</Radio.Button>
        </Radio.Group>
      </div>
      <div className="BarChart_chart-container">
        {noData ? (
          <CustomEmpty />
        ) : (
          <ResponsiveBar
            keys={data.keys}
            data={data.items}
            margin={{ top: 20, left: 35, right: 120, bottom: 20 }}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            tooltip={(item) => (
              <div className="BarChart_tooltip-container">
                <div className="BarChart_tooltip-color" style={{ backgroundColor: item.color }} />
                <div className="BarChart_tooltip-content">
                  <span className="BarChart_tooltip-id">{item.id}:</span>
                  <span className="BarChart_tooltip-value">{item.value}</span>
                </div>
              </div>
            )}
            legends={[
              {
                dataFrom: 'keys',
                anchor: 'right',
                direction: 'column',
                translateX: 120,
                translateY: 0,
                itemWidth: 100,
                itemHeight: 24,
                itemTextColor: '#333333',
                symbolSize: 16,
                symbolShape: 'circle'
              }
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default BarChart;
